var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65098 0.820507C7.24325 -0.273503 8.75646 -0.273502 9.34873 0.820508L11.1534 4.15399L14.7562 4.91081C15.9386 5.1592 16.4062 6.65751 15.5899 7.58202L13.1024 10.3991L13.5244 14.2003C13.6629 15.4478 12.4387 16.3738 11.3419 15.8512L7.99985 14.2587L4.65784 15.8512C3.56103 16.3738 2.33682 15.4478 2.47531 14.2003L2.89728 10.3991L0.409829 7.58202C-0.406523 6.65751 0.0610836 5.1592 1.24348 4.91081L4.84629 4.15399L6.65098 0.820507Z",
    fill: "#507AA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordStar);
export default __webpack_public_path__ + "static/media/password-star.fe8b4adedaa854219b95aa238627b855.svg";
export { ForwardRef as ReactComponent };